module.exports = function deprecatedMessage(previousUsage, newUsage) {
  var githubAnchorLink = previousUsage.toLowerCase()
    .replace('.', '')
    .replace('()', '');

  return 'algoliasearch: `' + previousUsage + '` was replaced by `' + newUsage +
    '`. Please see https://github.com/algolia/algoliasearch-client-js/wiki/Deprecated#' + githubAnchorLink;
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/deprecatedMessage.js
// module id = ./node_modules/algoliasearch/src/deprecatedMessage.js
// module chunks = 0 1